import React from 'react';

import { FontAwesomeSvgIcon } from '../components/FontAwesomeSvgIcon';
import { InputSelect } from '../components/InputSelect';
import { faBlind, faDeaf, faUser, faWalking, faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { setProfil } from '../store/actions/profilActions';
import { typeProfil } from '../enum/typeProfil';
import { useLabelValue } from '../utils/useLabelValue';
import { IconMenuItems } from '../components/Select/CustomMenuItem';
import { ConditionTypography } from '../components/Typography/ConditionTypography';
import { IconItemsList } from '../components/Select/CustomListItem';
import SvgS3AIcon from '../components/icons/mentIcon';
import { ConditionProfil } from './ConditionProfil';

const TypeSelectItem = props => {
  const {t} = useTranslation();

  const renderIcon = () => {
    switch (props['data-value']) {
      case typeProfil.TYPE_1:
        return <FontAwesomeSvgIcon icon={faWalking} ariaHidden={null} ariaLabel={t('form.profile-walk')}/>; 
      case typeProfil.TYPE_2:
        return <FontAwesomeSvgIcon icon={faBlind} ariaHidden={null} ariaLabel={t('form.profile-visual')}/>; 
      case typeProfil.TYPE_3:
        return <FontAwesomeSvgIcon icon={faWheelchair} ariaHidden={null} ariaLabel={t('form.profile-wheelchair')}/>; 
      case typeProfil.TYPE_4:
        return <FontAwesomeSvgIcon icon={faDeaf} ariaHidden={null} ariaLabel={t('form.profile-hearing')}/>; 
      case typeProfil.TYPE_5:
        return <SvgS3AIcon color="#0063a3" aria-hidden={null} aria-label={t('form.profile-mental')}/>; 
      default:
        return <React.Fragment />;
    }
  };
  let {selected, label} = props;
  return (
    <Tooltip 
      title={<p style = {{
        fontSize: '1.1em',
      }}>{label}</p>} 
      placement='bottom'
      arrow>
      <IconMenuItems active={selected ? 'true' : 'false'} {...props}>
        <IconItemsList active={selected ? 'true' : 'false'}>
          {renderIcon()}
        </IconItemsList>
      </IconMenuItems>
    </Tooltip>
  );
};

export const Options = ({isMobile, showCondition}) => {
  const profilRedux = useSelector(state => state.profils.profil);
  const conditionRedux = useSelector(state => state.profils.condition);
  const {t} = useTranslation();
  const {setLabelProfile} = useLabelValue();
  const dispatch = useDispatch();
  const handleProfile = profile => {
    dispatch(setProfil(profile));
  };
  const renderValueProfile = profile => {
    return (
      <ConditionTypography>
        {setLabelProfile(profile)}
      </ConditionTypography>
    );
  };

  return (
    <Stack direction= 'column' spacing={2}>
      <InputSelect 
        isMobile={isMobile} 
        icon={faUser} 
        label={t('form.profile-label')} 
        id='profil'
        role='presentation'
        value={profilRedux} 
        renderValue={() => renderValueProfile(profilRedux)}
        setValue={event => handleProfile(event.target.value)}>
        {Object.keys(typeProfil).map((type) => {
          return (
            <TypeSelectItem 
              value={typeProfil[type]}
              label={setLabelProfile(typeProfil[type])} 
              key={type}>
              {typeProfil[type]}
            </TypeSelectItem>
          );
        })}
      </InputSelect>
      <ConditionProfil 
        isMobile={isMobile} 
        profil={profilRedux} 
        conditionValue={conditionRedux}
        showInput={showCondition}/>
    </Stack>
  );
};
